import { FrameBody, Wait } from "@npd-ng/adp-benchmark"
import { IADPState } from "../types"
import { Content } from "../types/Content";
import { useStateContext } from "../hooks/useStateContext";
export default function WaitView(){
  const { state} = useStateContext();
  const content= state.staticContent as Content;
  const notifications = content.notifications
    return (
       <div>
       <FrameBody> 
        <Wait subTitle={notifications.internetConnecting}/>
        </FrameBody>
       </div>
    )
}